import { ReactNode, useMemo } from "react";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/react";

import { useWalletAccount } from "dapp-sdk";

import { formatNumber } from "@utils/globalCommon";

interface InputProps {
  inputLeftElement?: ReactNode;
  inputRightElement?: ReactNode;
  value: string;
  error?: string;
  isDisabled?: boolean;
  onChange(val: string): void;
}

const TicketInput = ({
  inputRightElement,
  value,
  error = "",
  isDisabled = false,
  onChange,
}: InputProps) => {
  const { isConnected } = useWalletAccount();
  const updatedValueWithComma = useMemo(() => {
    if (!value) return "";
    const values = value.split(".");
    const beforeDecimal = values[0];
    const afterDecimal = values.length > 1 ? `.${values[1]}` : "";
    return formatNumber(Number(beforeDecimal)) + afterDecimal;
  }, [value]);

  return (
    <InputGroup size="lg" mt={{ base: "12px", md: "1rem" }} mb="0">
      <Input
        type="text"
        placeholder="0.0"
        isInvalid={!!error}
        value={updatedValueWithComma}
        h="96px"
        disabled={isDisabled}
        onChange={(e) => onChange(e.target.value)}
        borderRadius="1rem"
        p={{
          base: "1.5rem 1rem",
          md: "1.5rem",
        }}
        fontWeight="600"
        fontSize={{
          base: "24px",
          md: "32px",
        }}
        color={value ? "textPrimary" : "textInput"}
        _placeholder={{
          color: "textInput",
        }}
        borderColor={error ? "error" : "seperator"}
        _focus={{
          boxShadow: "none",
          outline: "none",
          borderColor: error ? "error" : "primary",
          borderWidth: "1px",
        }}
        bg="backgroundPrimary"
        _hover={{
          borderColor: error ? "error" : "primary",
          borderWidth: "1px",
          _disabled: {
            borderWidth: "1px",
          },
        }}
        pr={{
          base: isConnected ? "92px" : "42px",
          lg: isConnected ? "140px" : "42px",
        }}
      />

      {inputRightElement && (
        <InputRightElement my="auto" h="100%" mr="1.5rem" w="auto">
          {inputRightElement}
        </InputRightElement>
      )}
    </InputGroup>
  );
};

export default TicketInput;
